let deviceInfo: any = null

export function deviceMagic(_el: Node, { Alpine }: any) {
  if (deviceInfo !== null) return deviceInfo

  const agent = navigator.userAgent.toLowerCase()

  let platform
  if (agent.includes('windows')) {
    platform = 'Windows'
  } else if (agent.includes('iphone')) {
    platform = 'iPhone'
  } else if (agent.includes('ipad')) {
    platform = 'iPad'
  } else if (agent.includes('mac')) {
    platform = 'MacOS'
  } else if (agent.includes('android')) {
    platform = 'Android'
  } else if (agent.includes('x11') && !agent.includes('linux')) {
    platform = 'UNIX'
  } else if (agent.includes('linux')) {
    platform = 'linux'
  } else {
    platform = 'other'
  }

  let browser
  if (agent.includes('chrome')) {
    browser = 'Chrome'
  } else if (agent.includes('firefox')) {
    browser = 'Firefox'
  } else if (agent.includes('safari')) {
    browser = 'Safari'
  } else if (agent.includes('msie')) {
    browser = 'Internet Explorer'
  } else {
    browser = 'other'
  }

  const [language = 'en'] = window.navigator.language.split(/[-_]/)

  deviceInfo = Alpine.reactive({
    platform,
    browser,
    language,
    mode: window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',
    features: {
      microphone: false,
      camera: false,
      speakers: false,
      geoposition: false
    },
    view: computeView()
  })

  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    deviceInfo.mode = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  })

  navigator.mediaDevices?.enumerateDevices().then(
    (devices) =>
      Object.assign(deviceInfo.features, {
        microphone: devices.some((d) => d.kind === 'audioinput'),
        camera: devices.some((d) => d.kind === 'videoinput'),
        speakers: devices.some((d) => d.kind === 'audiooutput')
      }),
    console.error
  )

  if (navigator.geolocation && navigator.permissions) {
    navigator.permissions.query({ name: 'geolocation' }).then(({ state }) => {
      deviceInfo.features.geoposition = ['granted', 'prompt'].includes(state)
    }, console.error)
  }

  function computeView() {
    const htmlEl = document.querySelector('html')
    return {
      orientation: window.innerWidth / window.innerHeight > 1 ? 'landscape' : 'portrait',
      fullWidth: window.innerWidth,
      fullHeight: window.innerHeight,
      actualWidth: htmlEl?.clientWidth!,
      actualHeight: htmlEl?.clientHeight!
    }
  }

  window.addEventListener('resize', () => (deviceInfo.view = computeView()))

  return deviceInfo
}
